module.exports = __webpack_public_path__ + "static/media/Delhi TMCP Icons-3 (1).ee904f51.png";